// extracted by mini-css-extract-plugin
export var root = "image-module--root--mV1SP";
export var image = "image-module--image---7MYf";
export var youtubeThumbnail = "image-module--youtubeThumbnail--FSWL1";
export var youtubeThumbnailImage = "image-module--youtubeThumbnailImage--8bTkv";
export var youtubePlay = "image-module--youtubePlay--xYLnJ";
export var youtubeContainer = "image-module--youtubeContainer--xmqua";
export var youtube = "image-module--youtube--RMOJ0";
export var lightbox = "image-module--lightbox--z8hxG";
export var x = "image-module--x--uHWL8";